"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.annotationSetSelectedAnnotationId = exports.annotationSetTouchPressed = exports.annotationSetDrawingNode = exports.annotationSetHoveredAnnotation = void 0;

var _constants = require("../constants");

/***************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2020 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 ***************************************************************************/

/**
 * Action to save the id of a hovered annotation
 * @param {string} annotationId - id of the hovered annotation
 * @return {object} action
 */
var annotationSetHoveredAnnotation = function annotationSetHoveredAnnotation(annotationId) {
  return {
    annotationId: annotationId,
    type: _constants.ANNOTATION_SET_HOVERED_ANNOTATION
  };
};
/**
 * Action to is drawing flag
 * @param {boolean} drawingNode - nodeId of node being drawn on
 * @return {object} action
 */


exports.annotationSetHoveredAnnotation = annotationSetHoveredAnnotation;

var annotationSetDrawingNode = function annotationSetDrawingNode(drawingNode) {
  return {
    drawingNode: drawingNode,
    type: _constants.ANNOTATION_SET_DRAWING_NODE
  };
};
/**
 * Action to set touch pressed
 * @param {boolean} touchPressed - boolean indicating if touch pressed
 * @return {object} action
 */


exports.annotationSetDrawingNode = annotationSetDrawingNode;

var annotationSetTouchPressed = function annotationSetTouchPressed(touchPressed) {
  return {
    touchPressed: touchPressed,
    type: _constants.ANNOTATION_SET_TOUCH_PRESSED
  };
};
/**
 * Action to set selected annotation
 * @param {string} selectedAnnotationId - id indicating selected annotation
 * @return {object} action
 */


exports.annotationSetTouchPressed = annotationSetTouchPressed;

var annotationSetSelectedAnnotationId = function annotationSetSelectedAnnotationId(selectedAnnotationId) {
  return {
    selectedAnnotationId: selectedAnnotationId,
    type: _constants.ANNOTATION_SET_SELECTED_ANNOTATION_ID
  };
};

exports.annotationSetSelectedAnnotationId = annotationSetSelectedAnnotationId;